const unixtimeToDate = unixtime =>
  new Date(Number(unixtime) * 1000).toLocaleDateString();

export { unixtimeToDate };
export default unixtimeToDate;
